type SortOrder = 'asc' | 'desc';

const compareDates = (firstDate: Date, secondDate: Date, order: SortOrder = 'asc') =>
  order === 'asc' ? firstDate.getTime() - secondDate.getTime() : secondDate.getTime() - firstDate.getTime();

export default compareDates;
